// "Schedule a call" as a modal overlay — the PhoneBand / nav entry point.
// The scheduler itself lives in ScheduleCallBody, shared with the
// schedule-call station so there is exactly one scheduler.

import { CalendarDaysIcon } from "@heroicons/react/24/outline";

import type { ScheduledCall } from "./api";
import FlowModal from "./FlowModal";
import ScheduleCallBody from "./ScheduleCallBody";

interface ScheduleCallModalProps {
  quoteId: string;
  contactPhone: string | null;
  /** True while the arrival machine hasn't granted this device a session
   * yet — see ScheduleCallBody's own doc comment. */
  credentialPending?: boolean;
  /** A call already on the books — the modal opens on its confirmation
   * instead of the picker. */
  existingCall?: ScheduledCall | null;
  /** Where the confirmation's Continue goes. From the quote screen this
   * is the application (the family may proceed without choosing a
   * package — the union of the health questions asks everything, and
   * package selection catches up later or on the call); omitted, it just
   * closes, because the application is already behind the modal. */
  onContinueToApplication?: () => void;
  onBooked: (call: ScheduledCall) => void;
  onClose: () => void;
}

export default function ScheduleCallModal({
  quoteId,
  contactPhone,
  credentialPending = false,
  existingCall,
  onContinueToApplication,
  onBooked,
  onClose,
}: ScheduleCallModalProps) {
  return (
    <FlowModal
      icon={CalendarDaysIcon}
      title="Talk to an agent"
      onClose={onClose}
    >
      <ScheduleCallBody
        quoteId={quoteId}
        contactPhone={contactPhone}
        credentialPending={credentialPending}
        existingCall={existingCall}
        onBookedContinue={onContinueToApplication ?? onClose}
        onBooked={onBooked}
        onClose={onClose}
      />
    </FlowModal>
  );
}
